import React from "react";
import BulkUploadDriverReservationModal from "../../components/BulkUploadDriverReservation";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";

const BulkUploadDriverReservation = (props) => {
  const allActions = MenuActionsMappings[MenuNames.DRIVER_RESERVATION];

  return (
    <Permission requiredPerms={[allActions.DRIVER_RESERVATIONS_BULK_CREATE]}>
      <BulkUploadDriverReservationModal />
    </Permission>
  );
};

export default BulkUploadDriverReservation;
